












































import { IClient } from "@/models/clients";
import { Component, Vue } from "vue-property-decorator";
import UPinInput from "@/components/app-base/UPinInput.vue";

@Component({
  components: {
    "client-search": () =>
      import("@/components/app/global/client/clientSearch.vue")
  }
})
export default class ClientVerifySupportPinModal extends Vue {
  public declare $refs: {
    pinInput: UPinInput;
  };

  // Data

  public supportPin = "";

  // Computed

  public get i18n() {
    return {
      title: this.$t("_action.verify_pin")
    };
  }

  // Methods

  public startOver() {
    this.$set(this, "supportPin", "");
    this.$nextTick(() => this.$refs.pinInput.init());
  }

  public onClientSelect(client: IClient) {
    this.$router
      .push({
        name: "adminClient",
        params: { clientId: client.id }
      })
      .then(() => {
        this.$emit("close");
      })
      .catch(() => {
        /** We are already in the same client view */
        const clientView = this.$route.matched.find(
          i => i.name === "adminClient"
        );
        if (clientView && this.$route.params?.clientId === client.id)
          this.$emit("close");
      });
  }
}
